/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_discover_more_button_text36 = /** @type {(inputs: {}) => string} */ () => {
	return `Discover published Open Education Resources`
};

const fr_oer_information_discover_more_button_text36 = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrez les ressources éducatives libres publiées`
};

const de_oer_information_discover_more_button_text36 = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie veröffentlichte Open Education Resources`
};

const es_oer_information_discover_more_button_text36 = /** @type {(inputs: {}) => string} */ () => {
	return `Descubra los recursos educativos abiertos publicados`
};

const it_oer_information_discover_more_button_text36 = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri le risorse educative aperte pubblicate`
};

const ar_oer_information_discover_more_button_text36 = /** @type {(inputs: {}) => string} */ () => {
	return `اكتشف الموارد التعليمية المفتوحة المنشورة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_discover_more_button_text36 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_discover_more_button_text36(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_discover_more_button_text36", locale)
	if (locale === "en") return en_oer_information_discover_more_button_text36(inputs)
	if (locale === "fr") return fr_oer_information_discover_more_button_text36(inputs)
	if (locale === "de") return de_oer_information_discover_more_button_text36(inputs)
	if (locale === "es") return es_oer_information_discover_more_button_text36(inputs)
	if (locale === "it") return it_oer_information_discover_more_button_text36(inputs)
	return ar_oer_information_discover_more_button_text36(inputs)
};
export { oer_information_discover_more_button_text36 as "OER_INFORMATION_DISCOVER_MORE_BUTTON_TEXT" }